import { FormControl } from '@angular/forms';
import { ApplianceDetailsFormField } from './appliance-details-form-field.enum';

export interface ApplianceDetailsForm {
  [ApplianceDetailsFormField.ApplianceCategory]: FormControl<string | null>;
  [ApplianceDetailsFormField.ApplianceCode]: FormControl<string | null>;
}
